import { HelpCircle } from 'lucide-react';
import { formatNXC } from '../lib/formatNXC';

/**
 * BalanceChip — direction-aware money chip.
 * Positive = the person gets money back ("To get"), negative = they must pay ("To pay").
 * Tap opens the "where this number comes from" sheet when onExplain is given.
 */
export default function BalanceChip({ amount, currency = 'INR', onExplain, testId, size = 'md' }) {
  const n = Math.round(Number(amount) || 0);
  const settled = n === 0;
  const tone = settled
    ? 'bg-muted text-muted-foreground'
    : n > 0
      ? 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300'
      : 'bg-rose-500/15 text-rose-700 dark:text-rose-300';
  const label = settled ? 'Settled' : `${n > 0 ? 'To get' : 'To pay'} ${formatNXC(Math.abs(n), currency)}`;
  const pad = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-xs';
  const Tag = onExplain ? 'button' : 'span';

  return (
    <Tag
      {...(onExplain ? { type: 'button', onClick: onExplain, title: 'How is this calculated?' } : {})}
      data-testid={testId}
      className={`shrink-0 rounded-full font-bold tabular-nums whitespace-nowrap inline-flex items-center gap-1 ${pad} ${tone} ${onExplain ? 'active:scale-95 transition' : ''}`}
    >
      {label}
      {onExplain && <HelpCircle className="w-3 h-3 opacity-60" />}
    </Tag>
  );
}
